import { parseColor } from "@ortex-charts/core";

/**
 * The two colour operations the charts need, on top of the library's parser:
 * an alpha and a brightness shift. Accepts hex, rgb(a) and named colours.
 */
export function alpha(color: string, a: number): string {
    const [r, g, b] = parseColor(color);
    return `rgba(${r}, ${g}, ${b}, ${Math.max(0, Math.min(1, a))})`;
}

/** Positive `amount` lightens, negative darkens; 0 returns the colour unchanged. */
export function brighten(color: string, amount: number): string {
    const [r, g, b, a] = parseColor(color);
    const shift = Math.round(amount * 255);
    const c = (v: number) => Math.max(0, Math.min(255, v + shift));
    return a >= 1 ? `rgb(${c(r)}, ${c(g)}, ${c(b)})` : `rgba(${c(r)}, ${c(g)}, ${c(b)}, ${a})`;
}
